import Common from '../../Common';
import Account from './pbx/Account';
import Announcement from './pbx/Announcement';
import CallbackRecording from './pbx/CallbackRecording';
import CallerIdRoute from './pbx/CallerIdRoute';
import Cfc from './pbx/Cfc';
import Changes from './pbx/Changes';
import Cid from './pbx/Cid';
import Destination from './pbx/Destination';
import Device from './pbx/Device';
import Did from './pbx/Did';
import Dirty from './pbx/Dirty';
import Ivr from './pbx/IVR';
import IsUsed from './pbx/IsUsed';
import Language from './pbx/Language';
import MOH from './pbx/MOH';
import MiscApp from './pbx/MiscApp';
import ModuleLock from './pbx/ModuleLock';
import Num2Mail from './pbx/Num2Mail';
import Page from './pbx/Page';
import Queue from './pbx/Queue';
import QueueCallerPriority from './pbx/QueueCallerPriority';
import QueueSkill from './pbx/QueueSkill';
import Reload from './pbx/Reload';
import RingGroup from './pbx/RingGroup';
import SetCid from './pbx/SetCid';
import SetLanguage from './pbx/SetLanguage';
import Setting from './pbx/Setting';
import Soundfile from './pbx/Soundfile';
import Tbr from './pbx/Tbr';
import User from './pbx/User';
import UserCallBlock from './pbx/UserCallBlock';

export interface GetDestinationsItem {
	name: string
	id: id
	description: string
	pbx_destination_id: id
}

export interface GetDestinationObject {
	[key: id]: GetDestinationsItem
}

export interface GetDestinations {
	Select: any // GetDestinationsItem[]
	announcement: GetDestinationObject
	callback: GetDestinationObject
	callbackrecording: GetDestinationObject
	calleridroute: GetDestinationObject
	cfc: GetDestinationObject
	destination: GetDestinationObject
	ivr: GetDestinationObject
	miscapp: GetDestinationObject
	num2mail: GetDestinationObject
	page: GetDestinationObject
	queue: GetDestinationObject
	queuecallerpriority: GetDestinationObject
	queueskill: GetDestinationObject
	ringgroup: GetDestinationObject
	setcid: GetDestinationObject
	setlanguage: GetDestinationObject
	tbr: GetDestinationObject
	blackhole: GetDestinationObject
	user: GetDestinationObject
	voicemail: GetDestinationObject
	[key: string]: GetDestinationObject // | GetDestinationsItem[]
}

const PBX = class extends Common {
	account: InstanceType<typeof Account>;
	announcement: InstanceType<typeof Announcement>;
	callbackRecording: InstanceType<typeof CallbackRecording>;
	callerIdRoute: InstanceType<typeof CallerIdRoute>;
	cid: InstanceType<typeof Cid>;
	destination: InstanceType<typeof Destination>;
	device: InstanceType<typeof Device>;
	did: InstanceType<typeof Did>;
	ivr: InstanceType<typeof Ivr>;
	miscApp: InstanceType<typeof MiscApp>;
	num2Mail: InstanceType<typeof Num2Mail>;
	page: InstanceType<typeof Page>;
	queue: InstanceType<typeof Queue>;
	queueCallerPriority: InstanceType<typeof QueueCallerPriority>;
	queueSkill: InstanceType<typeof QueueSkill>;
	ringGroup: InstanceType<typeof RingGroup>;
	setCid: InstanceType<typeof SetCid>;
	setLanguage: InstanceType<typeof SetLanguage>;
	soundfile: InstanceType<typeof Soundfile>;
	tbr: InstanceType<typeof Tbr>;
	cfc: InstanceType<typeof Cfc>;
	isUsed: InstanceType<typeof IsUsed>;
	reload: InstanceType<typeof Reload>;
	changes: InstanceType<typeof Changes>;
	dirty: InstanceType<typeof Dirty>;
	user: InstanceType<typeof User>;
	language: InstanceType<typeof Language>;
	moh: InstanceType<typeof MOH>;
	setting: InstanceType<typeof Setting>;
	moduleLock: InstanceType<typeof ModuleLock>;
	userCallBlock: InstanceType<typeof UserCallBlock>;

	constructor(headers: ApiHeaders) {
		super(headers)
		this.account = new Account(headers);
		this.announcement = new Announcement(headers);
		this.callbackRecording = new CallbackRecording(headers);
		this.callerIdRoute = new CallerIdRoute(headers);
		this.cid = new Cid(headers);
		this.destination = new Destination(headers);
		this.device = new Device(headers);
		this.did = new Did(headers);
		this.ivr = new Ivr(headers);
		this.miscApp = new MiscApp(headers);
		this.num2Mail = new Num2Mail(headers);
		this.page = new Page(headers);
		this.queue = new Queue(headers);
		this.queueCallerPriority = new QueueCallerPriority(headers);
		this.queueSkill = new QueueSkill(headers);
		this.ringGroup = new RingGroup(headers);
		this.setCid = new SetCid(headers);
		this.setLanguage = new SetLanguage(headers);
		this.soundfile = new Soundfile(headers);
		this.tbr = new Tbr(headers);
		this.isUsed = new IsUsed(headers);
		this.cfc = new Cfc(headers);
		this.reload = new Reload(headers);
		this.changes = new Changes(headers)
		this.dirty = new Dirty(headers)
		this.user = new User(headers)
		this.language = new Language(headers)
		this.moh = new MOH(headers)
		this.setting = new Setting(headers)
		this.moduleLock = new ModuleLock(headers)
		this.userCallBlock = new UserCallBlock(headers)
	}

	getDestinations = (companyId: id): CustomResponse<GetDestinations> =>
		this.get(`/company/${companyId}/pbx/destinations`)

	isExtensionAvailable = (companyId: id, extension: string) =>
		this.get(`/company/${companyId}/pbx/extenavailable/${extension}`)

	getExtensFeatures = (companyId: id) =>
		this.get(`/company/${companyId}/pbx/extensfeatures`)

	getDeviceTemplates = (companyId: id) =>
		this.get(`/company/${companyId}/pbx/devicetemplates`)

	getDeviceTemplatesData = (companyId: id) =>
		this.get(`/company/${companyId}/pbx/devicetemplatesdata`)

	getButtonFunctions = (companyId: id) =>
		this.get(`/company/${companyId}/pbx/buttonfunctions`)

	getDeviceTemplateOptions = (companyId: id, deviceTemplateOptionsId: id) =>
		this.get(`/company/${companyId}/pbx/devicetemplateoptions/${deviceTemplateOptionsId}`)

	getLanguages = (companyId: id): CustomResponse<PbxLanguages> =>
		this.get(`/company/${companyId}/pbx/languages`)

	getPasswd = (companyId: id) =>
		this.get(`/company/${companyId}/pbx/passwd`)
}

export default PBX
